<template>
    <div>
        <a href="#" id="scrollToTop" v-scroll-to="'#main-nav'">
            <i class="fas fa-arrow-up text-light"></i>
        </a>
    </div>
</template>

<script>
export default {
    created() {
        window.addEventListener("scroll", this.handleScroll);
    },
    destroyed() {
        window.removeEventListener("scroll", this.handleScroll);
    },
    methods: {
        handleScroll(event) {
            this.isUserScrolling = window.scrollY > 200;
            if (this.isUserScrolling) {
                $("#scrollToTop").css("display", "flex");
            } else $("#scrollToTop").css("display", "none");
        }
    }
};
</script>

<style lang="scss" scoped>
#scrollToTop {
    position: fixed;
    display: none;
    bottom: 2rem;
    right: 2rem;
    z-index: 1000;
    border-radius: 50%;
    background: #cd1b00;
    width: 3.4rem;
    height: 3.4rem;
    padding: 0.3rem;
    font-size: 2.2rem;
    align-items: center;
    justify-content: center;
    &:hover {
        cursor: pointer;
    }
}
</style>
